import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';

import RootStore from 'stores/RootStore';

import Button from 'components/Button/Button';
import style from './OutdatedVersionScreen.module.scss';

@observer
class OutdatedVersionScreen extends Component<{ link: string }> {
  render() {
    return (
      <main className={style.main}>
        <div className={style.title}>
          <FormattedMessage id="title.userProfile.outdated" />
        </div>

        <div className={style.link}>
          <FormattedMessage id="title.userProfile.outdated.link" />
          <a href={this.props.link}>{this.props.link}</a>
        </div>

        <div className={style.logout}>
          <Button onClick={RootStore.user.logout}>
            <FormattedMessage id="button.logout" />
          </Button>
        </div>
      </main>
    );
  }
}

export default OutdatedVersionScreen;
